(function () {
  function balance(container) {
    if (container.dataset.stBalanced) return;
    container.dataset.stBalanced = '1';
    var groups = Array.prototype.slice.call(container.querySelectorAll('.st-grp'));
    if (!groups.length) return;
    var height = function (g) {
      return parseInt(g.getAttribute('data-st-lines') || '2', 10) || 2;
    };
    var remaining = groups.reduce(function (s, g) { return s + height(g); }, 0);
    var nCols = remaining > 80 ? 5 : Math.min(4, groups.length);
    container.innerHTML = '';
    var col = document.createElement('div');
    col.className = 'st-col';
    container.appendChild(col);
    var used = 1;
    var acc = 0;
    var target = remaining / nCols;
    groups.forEach(function (g) {
      var h = height(g);
      if (acc > 0 && used < nCols && acc + h / 2 > target) {
        col = document.createElement('div');
        col.className = 'st-col';
        container.appendChild(col);
        used++;
        acc = 0;
        target = remaining / (nCols - used + 1);
      }
      col.appendChild(g);
      acc += h;
      remaining -= h;
    });
    while (used < nCols) {
      var filler = document.createElement('div');
      filler.className = 'st-col';
      container.appendChild(filler);
      used++;
    }
  }

  function init() {
    document.querySelectorAll('[data-st-cols]').forEach(balance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
